import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';

export const defaultValuesTableColumns: TableColumn[] = [
  { id: 'carrier', label: '', align: 'left', sortDisabled: true, width: '120px' },
  { id: 'moveCount', label: 'Move count', align: 'left', sortDisabled: true },
  { id: 'moveCountStretch', label: 'Threshold L2', align: 'left', sortDisabled: true },
  { id: 'moveCountCritical', label: 'Threshold L3', align: 'left', sortDisabled: true },
  { id: 'validityPeriod', label: 'Validity period', align: 'left', sortDisabled: true },
  { id: 'actions', label: 'Actions', align: 'right', width: '200px', sortDisabled: true },
];

export const weeklyValuesTableColumns: TableColumn[] = [
  { id: 'carrier', label: '', align: 'left', sortDisabled: true, width: '120px' },
  { id: 'date', label: 'Date', align: 'left' },
  { id: 'moveCount', label: 'Move count', align: 'left' },
  { id: 'moveCountStretch', label: 'Threshold L2', align: 'left' },
  { id: 'moveCountCritical', label: 'Threshold L3', align: 'left' },
  { id: 'status', label: 'Status', align: 'left' },
  { id: 'actions', label: 'Actions', align: 'right', width: '200px', sortDisabled: true },
];

export const editCarriersTableColumns: TableColumn[] = [
  { id: 'carrier', label: '', align: 'left', sortDisabled: true, width: '190px' },
  { id: 'moveCount', label: 'Move count', align: 'left', sortDisabled: true },
  { id: 'moveCountStretch', label: 'Threshold L2', align: 'left', sortDisabled: true },
  { id: 'moveCountCritical', label: 'Threshold L3', align: 'left', sortDisabled: true },
  { id: 'actions', label: 'Actions', align: 'right', width: '100px', sortDisabled: true },
];

export const editCarriersWeeklyTableColumns: TableColumn[] = [
  { id: 'carrier', label: '', align: 'left', sortDisabled: true, width: '230px' },
  { id: 'moveCount', label: 'Move count', align: 'left', sortDisabled: true, width: '200px' },
  { id: 'moveCountStretch', label: 'Threshold L2', align: 'left', sortDisabled: true },
  { id: 'moveCountCritical', label: 'Threshold L3', align: 'left', sortDisabled: true },
];

export const editCarriersYardTableColumns: TableColumn[] = [
  { id: 'carrier', label: '', align: 'left', sortDisabled: true, width: '190px' },
  { id: 'yardCapacity', label: 'Yard TEU capacity', align: 'left', sortDisabled: true },
  { id: 'reeferPlugs', label: 'Reefer plugs', align: 'left', sortDisabled: true },
  { id: 'imoUnits', label: 'IMO Units', align: 'left', sortDisabled: true },
  { id: 'oogUnits', label: 'OOG Units', align: 'left', sortDisabled: true },
];
